import { Alert, Box } from "@mui/material";
import get from "lodash/get";
import { GrafanaRequestButton } from "../components/grafanaButton";
import { Column } from "../components/column";
import { Row } from "../components/row";

const getRequestId = (error) => {
  return (
    get(error, "body.request_id") ||
    get(error, "request_id") ||
    get(error, "response.headers.x-request-id") ||
    ""
  );
};

const getRequestIdLabel = (request_id) => {
  if (request_id) {
    request_id = ` (request_id: ${request_id} )`;
  }

  return request_id;
};

const getDetailLabel = (error) => {
  let detail =
    get(error, "body.detail") ||
    get(error, "detail") ||
    get(error, "response.data.detail") ||
    "";

  if (Array.isArray(detail)) {
    return detail;
  }

  if (detail) {
    detail = ` -> ${detail}`;
  }

  return detail;
};

const parseArrayItemErrorMessage = (err) => {
  const loc = err.loc;

  let source = Array.isArray(loc) ? loc[loc.length - 1] : "";
  if (["unknown"].includes(source)) {
    source = "";
  }

  let errorIdx =
    Array.isArray(loc) && loc.length > 1 ? loc[loc.length - 2] : "";
  if (!Number.isInteger(errorIdx)) {
    errorIdx = "";
  }
  const msg = err.msg || get(err, "ctx.message");

  return { source, errorIdx, msg };
};

const getArrayItemErrorMessageData = (err) => {
  const { source, errorIdx, msg } = parseArrayItemErrorMessage(err);

  const source_label = source ? source + ": " : source;
  const errorIdx_label = errorIdx ? `Entry #${errorIdx}: ` : "";

  const errorMessage = `${errorIdx_label}${source_label}${msg}`;

  return { source, errorIdx, msg, errorMessage };
};

export const parseError = (error) => {
  return {
    detail: getDetailLabel(error),
    request_id: getRequestId(error),
    message: error?.message,
  };
};

export const getErrorMessageData = (error, glue = ". ") => {
  let { detail, request_id, message } = parseError(error);
  let errorMessage = "";

  if (Array.isArray(detail)) {
    detail = detail.map(getArrayItemErrorMessageData);
    errorMessage = detail.map((d) => d.errorMessage).join(glue);
  } else {
    errorMessage =
      (message || "Unknown error") + detail + getRequestIdLabel(request_id);
  }

  return { detail, request_id, message, errorMessage };
};

export const getErrorMessage = (error) => {
  const messageData = getErrorMessageData(error);
  return messageData.errorMessage;
};

export const errorDisplayConfig = {
  autoHideDuration: 10000,
  multiLine: true,
  type: "error",
};

export const errorHandlingFactory = (
  notifier,
  isSuperuser = false,
  glue = ". "
) => {
  const onError = (error) => {
    const messageData = getErrorMessageData(error, glue);
    let errorMessage = messageData.errorMessage;

    if (isSuperuser && messageData.request_id && error.status == 500) {
      errorMessage = (
        <Alert severity="error">
          <Row>
            <Column sx={{ flexGrow: 3 }}>
              {errorMessage.split(glue).map((errorLine, idx) => (
                <Box key={idx}>{errorLine}</Box>
              ))}
            </Column>
            <Column>
              <GrafanaRequestButton request_id={messageData.request_id} />
            </Column>
          </Row>
        </Alert>
      );
    }

    notifier(errorMessage, errorDisplayConfig);
    return messageData;
  };

  return onError;
};
